<template>
    <div>
      <div class="Dao-yuan-banner" v-bind:style="{backgroundImage:'url(' + bg + ')',backgroundSize: 'cover' ,backgroundPosition:'center',backgroundRepeat:'no-repeat'}">
        <head-menu   fd="0"  current="2"></head-menu>
        <img :src="bg" class="Dao-yuan-banner-img" style="display:block;width: 100%;position: relative;z-index: -100">
      </div>

       <div>
         <el-row class="show-recruit-head-tlie2"  style="margin-top: 40px">
           <el-col :lg="{span:11,offset:0}":md="{span:12,offset:0}" :xs="24" style="margin-top: 30px;margin-bottom: 10px">
             <div style="width: 99%;height: 1px;background-color:rgb(229, 229, 229);margin-top: 26px;" ></div>
           </el-col>
           <el-col :lg="{span:12,offset:0}":md="{span:12,offset:0}" :xs="24" style="margin-top: 30px;margin-bottom: 10px" >
             <h3 style="font-weight: bold;border-bottom:1px solid #e5e5e5;padding-bottom: 10px;font-size: 40px;width: 99%;margin-left: 1%">
               <span style="border-bottom: 2px solid #083A6F;padding-bottom: 10px;font-family:Microsoft YaHei;">Career</span>
             </h3>
             <div  style="font-size:30px;color:rgba(8,58,111,1);margin-top: 10px;text-align: left;width: 99%;margin-left:-1%;font-family:Microsoft YaHei;">&nbsp;&nbsp;人才招聘</div>
           </el-col>
         </el-row>
         <div style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em" class="show-recruit-head-tlie"> </div>
         <div class="show-recruit-head-tlie"  style="text-align:center;font-weight: bold;padding-bottom: 10px;font-size: 2em;border-bottom:1px solid #e5e5e5;font-family:Microsoft YaHei;">Career</div>
         <div class="show-recruit-head-tlie"  style="font-size:22px;color:rgba(8,58,111,1);margin-top: 10px;text-align: center;font-family:Microsoft YaHei;">人才招聘</div>
         <el-row class="show-recruit-head-tlie2"  style="margin-top: 40px">
           <el-col :lg="{span:24,offset:0}":md="{span:24,offset:0}" :xs="0">
             <div style="height: 28px"></div>
           </el-col>
         </el-row>


         <div v-for="(item,index) in newList" class="Dao-yuan-family-nr text-info-top">
           <el-row>
             <el-col :lg="{span:11,offset:0}" :sm="{span:22,offset:1}" :md="{span:12,offset:0}" :xs="{span:0,offset:0}" stlye="text-align: justify">
               <img style="display: block;width: 100%" :src="bg1" >
             </el-col>
             <el-col  :lg="{span:12,offset:1}" :sm="{span:24,offset:0}" :md="{span:11,offset:1}" :xs="{span:20,offset:2}" stlye="text-align: justify">
                  <!-- 新加的临时职位 -->
                 <div>投资副总裁/投资总监(医疗器械)</div>
                 <!-- <div><spnd>工作时间：</spnd><span style="color: #666666">{{item.workingHours}}</span></div> -->
                 <div><spnd>职位描述：</spnd><span style="color: #666666">
                   <br>&emsp;○医疗器械行业分析及投资策略指定；
                   <br>&emsp;○开展医疗器械领域的项目搜寻
                   、谈判、调研;对拟投资项目组织实施投资运作，组织谈判、进行尽职调查、设计交易结构，组织编制投资尽调报告/投资建议书及相关投资决策文件等工作；
                   <br>
                   &emsp;○跟进项目落地，协同投后管理部门进行投后管理工作。</span></div>
                 <div><spnd>职位要求：</spnd><span style="color: #666666"><br>
                   &emsp;○国内211/985学校生物医学工程、材料学或相关专业硕士及以上学历；<br>
                   &emsp;○在医疗公司从事5年以上研发工作；<br>
                   &emsp;○熟悉医疗器械企业运营，了解医疗和医疗器械行业业态<br>
                   &emsp;○学习能力强，对新技术有强烈兴趣，对投资有兴趣；<br>
                   &emsp;○逻辑思维和分析能力强、良好的口头和文字表达能力；<br>
                   &emsp;○适应经常出差
                   </span></div>
                  <div><spnd>联系邮箱：</spnd><span style="color: #666666">具有竞争力的薪资及奖金，内部晋升机制完善，注重员工培养，职业发展空间大。</span></div>
                 <div><spnd>联系邮箱：</spnd><span style="color: #666666">hr@taocapital.cn</span></div>
                 <div><spnd>邮箱主题：</spnd><span style="color: #666666">投资副总裁/投资总监</span></div>
               <div v-if="language == 'CN'" class="Dao-yuan-text"  style="line-height: 30px;margin-top: 50px">
                 <div>{{item.position}}</div>
                 <div><spnd>工作时间：</spnd><span style="color: #666666">{{item.workingHours}}</span></div>
                 <div><spnd>职位描述：</spnd><span style="color: #666666">{{item.jobDescription}}</span></div>
                 <div><spnd>职位要求：</spnd><span style="color: #666666">{{item.jobRequirements}}</span></div>
                 <div><spnd>联系邮箱：</spnd><span style="color: #666666">{{item.mail}}</span></div>
                 <div><spnd>邮箱主题：</spnd><span style="color: #666666">{{item.mailTheme}}</span></div>
               </div>
                <div v-if="language == 'EN'" class="Dao-yuan-text"  style="line-height: 30px;margin-top: 50px">
                 <div>Investment Analysis Intern (this position is valid forever) </div>
                 <div><spnd>Working hours:</spnd><span style="color: #666666">no less than 4 working days per week, more than 3 months of internship with excellent performance is preferential recruitment</span></div>
                 <div><spnd>Job Description: </spnd><span style="color: #666666">Participate in all aspects of investment work as the main force, including industry analysis, market research, financial analysis, transaction structure design, due diligence, etc</span></div>
                 <div><spnd>Job requirements:</spnd><span style="color: #666666">medicine, biology, pharmacy, finance, accounting, and other majors. Can be employed immediately after passing the interview and people who have enough time are preferred, Junior or master's degree students</span></div>
                 <div><spnd>Contact email: </spnd><span style="color: #666666"> hr@taocapital.cn (please send your resume to this email)</span></div>
                 <div><spnd>Email subject:</spnd><span style="color: #666666">Tao Capital Intern-School-Name-Major-Internship days per week-Contact Information</span></div>
               </div>
             </el-col>
           </el-row>
           <div v-if="index!=dataSize-1" style="width: 100%;margin-top: 50px;height: 2px;background-color: #919191"></div>
         </div>

       </div>

      <div style="height: 100px"></div>
      <footee></footee>

    </div>

</template>

<script>
  import HeadMenu from '../../share/head-mean'
  import footee from '../../share/footer.vue'
  import BK from '../../share/fh.vue'
  export default {
    components:{
      "head-menu":HeadMenu,
      "footee":footee,
      "BK":BK
    },
    name: "newsCenteru",
    data(){
      return {
        bg: require('@/assets/24.jpg'),
        bg1: require('@/assets/bodyimg.jpg'),
        type:1,
        language:'CN',
        dataSize:-1,
        newList:[
          // {
          //   position:'投研分析岗实习生（本职位长期有效）',
          //   workingHours:'每周到岗不少于4个工作日 ,实习期3个月以上表现优异优先录用。',
          //   jobDescription:'作为助理参与投资工作的各个环节，包括行业分析、市场调研、财务分析、交易架构设计、尽职调查等。',
          //   jobRequirements:'医学、生物、药学、金融、财务等专业。安排面试合格后能立即入职、时间充裕者优先，三年级以上本科生或硕士研究生。',
          //   mail:'hr@taocapital.cn（请发送简历至此邮箱）',
          //   mailTheme:'道远资本实习生-学校-姓名-专业-每周可实习几天-联系方式'
          // }
        ],


      }
    },created() {
      this.getlist()
    },methods:{
      handleSelect(key){
        this.activeIndex=key
      },getlist(){
        this.$axios.post('/daoyuanFamily/getText',{}).then(res=>{
          this.newList=res.data.entity
          this.dataSize=this.newList.length;
        })
      }
    },
    mounted(){
    if(localStorage.getItem('language')){
      this.language =localStorage.getItem('language')
    }else{
      this.language = 'CN'
    }
    }
  }
</script>

<style scoped>
.itemx-our-1{
  height: 54px !important;
  line-height: 54px !important;
  margin-top: 0px !important;
}
.xz1{
  border-bottom: 2px solid #083A6F !important;
}
.Dao-yuan-family-nr{
  max-width: 1210px;
  background:#FFFFFF;
  margin: 0 auto;
  margin-top:100px;
}

/*.Dao-yuan-family-nr:hover{*/
/*  box-shadow:5px 8px 10px 0px rgba(188,188,188,0.53), -4px -8px 10px 0px rgba(188,188,188,0.15);*/
/*  border-bottom: 2px solid rgba(8,58,111,1);*/
/*  background-color: #fff;*/
/*}*/
.Dao-yuan-family-text-one{
  font-size:16px;
  line-height:20px;
  font-weight:400;
  float: left;
}
.Dao-yuan-family-text-tow{
   font-size:14px;
   font-weight:400;
   color:rgba(152,152,152,1);
   float: right;
   line-height: 29px;
 }
.Dao-yuan-family-text-three{
  margin-top: 45px;
  color:rgba(152,152,152,1);
  line-height:28px;
  font-size: 14px;
}
.Dao-yuan-family-tile{
  margin-top: 70px;
  text-align: center;
  font-size:30px;
  font-weight:400;
}
  /deep/ .el-menu-item{
    padding: 0px;
  }
/deep/ .el-menu--horizontal>.el-menu-item.is-active{
  font-weight:bold;
  color:rgba(8,58,111,1);
  border-bottom: 0px;
}
.gd{
  height: 150px !important;
}
@media screen and (min-width: 1210px){
  .Dao-yuan-banner{
    height: 400px;
  }
  .Dao-yuan-banner-img{
    display: none !important;
  }
  .Dao-yuan-news{
    margin-left: -20px;
    padding: 20px;
  }
  .show-recruit-head-tlie{
    display: none;
  }

}

@media screen and (max-width: 1210px){
  .show-recruit-head-tlie2{
    display: none;
  }
}

@media screen and (min-width: 750px){

  .text-info-top{
    margin-top: 40px
  }

}

@media screen and (max-width: 750px){
  .Dao-yuan-text{
    margin-left: 10px !important;
  }
  .text-info-top{
    margin-top: 0px
  }

}
</style>



// WEBPACK FOOTER //
// src/components/DaoyuanFamily/index.vue